import styled from 'styled-components';

export const TooltipLabel = styled.p`
  padding: 0.33rem 0.6rem;
  border: 0px solid transparent;
  border-radius: 1rem;
  color: #00004a;
  font-size: 0.9rem;
  font-weight: 600;
  background: #ffffde;
  transform: translateY(-0.25rem);
  opacity: 0.8;
`;
